import { Collapse, List, ListItemButton, ListItemText } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { createStyles, makeStyles } from '@mui/styles';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { useState } from 'react';
import { NavLink } from 'react-router';

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    root: {
      width: '297px',
      height: '100%',
      backgroundColor: '#fff',
      padding: '0px 15px',
    },
    section1: {
      padding: '40px 0px',
      borderBottom: '1px solid #e8edf2',
      '& span': {
        marginRight: '11px',
      },
      '& h4': {
        margin: '0px',
        color: '#564545',
        textTransform: 'capitalize',
        fontSize: '16px',
        fontWeight: 600,
        textAlign: 'center',
      },
      '& p': {
        margin: '0px',
        textAlign: 'center',
        color: '#8f8f8f',
        fontSize: '14px',
        fontWeight: 300,
        letterSpacing: '3px',
      },
    },
    list: {
      '& .MuiTypography-root': {
        color: '#564545',
        fontSize: '14px',
        fontWeight: 400,
      },
      '& a': {
        textDecoration: 'none',
        textTransform: 'capitalize',
      },
      '& a.active .MuiTypography-root': {
        color: theme.palette.primary.main,
      },
    },
    nestedList: {
      paddingLeft: '25px',
    },
  })
);

// const sidebarData = [
//   {
//     id: 'intro',
//     label: 'introduction',
//     to: '/help',
//   },
//   {
//     id: 'dashboard',
//     label: 'dashboard',
//     to: '/help/dashboard',
//   },
//   {
//     id: 'project',
//     label: 'Project',
//     to: '/help/project',
//   },
//   {
//     id: 'contacts',
//     label: 'contacts',
//     to: '/help/contacts',
//   },
//   {
//     id: 'multi-lang-support',
//     label: 'multi-language support',
//     to: '/help/multi-lang-support',
//   },
//   {
//     label: 'cases',
//     children: [
//       {
//         id: 'cases',
//         label: 'cases',
//         to: '/help/cases',
//       },
//       {
//         id: 'view-cases',
//         label: 'viewing cases',
//         to: '/help/cases/view',
//       },
//       {
//         id: 'creating-cases',
//         label: 'creating cases',
//         to: '/help/cases/create',
//       },
//     ]
//   },
// ];

const HelpLayoutSidebar = () => {
  const classes = useStyles();
  const [open, setOpen] = useState<boolean>(false);
  const handleCollapse = () => {
    setOpen(!open);
  };
  return (
    <>
      <div className={classes.root}>
        <div className={classes.section1}>
          <h4>
            <span>
              <img
                src="/static/icons/home-icon.svg"
                alt="home icon"
                width="14px"
                height="14px"
              />
            </span>
            Portal User Guide
          </h4>
          <p>12.52.1542</p>
        </div>
        <List
          component="nav"
          className={classes.list}
        >
          <NavLink
            to="/help"
          >
            <ListItemButton >
              <ListItemText primary="Introduction" />
            </ListItemButton>
          </NavLink>
          <NavLink
            to="/help/dashboard"
          >
            <ListItemButton >
              <ListItemText primary="Dashboard" />
            </ListItemButton>
          </NavLink>
          <ListItemButton
            
            onClick={handleCollapse}
          >
            <ListItemText primary="Cases" />
            {open ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse
            in={open}
            timeout="auto"
            unmountOnExit
          >
            <List
              component="div"
              disablePadding
              className={classes.nestedList}
            >
              <NavLink
                to="/help/cases"
              >
                <ListItemButton >
                  <ListItemText primary="Cases" />
                </ListItemButton>
              </NavLink>
              <NavLink
                to="/help/cases/view"
              >
                <ListItemButton >
                  <ListItemText primary="Viewing Cases" />
                </ListItemButton>
              </NavLink>
              <NavLink
                to="/help/cases/create"
              >
                <ListItemButton >
                  <ListItemText primary="Creating Cases" />
                </ListItemButton>
              </NavLink>
            </List>
          </Collapse>
          <NavLink
            to="/help/project"
          >
            <ListItemButton >
              <ListItemText primary="Project" />
            </ListItemButton>
          </NavLink>
          <NavLink
            to="/help/contacts"
          >
            <ListItemButton >
              <ListItemText primary="Contacts" />
            </ListItemButton>
          </NavLink>
          {/* <NavLink
            to="/help/multi-lang-support"
          >
            <ListItemButton >
              <ListItemText primary="Multi-language Support" />
            </ListItemButton>
          </NavLink> */}
        </List>
      </div>
    </>
  );
};

export default HelpLayoutSidebar;
